module.exports = __webpack_public_path__ + "media/images/favicons/favicon-wednesday-16x16-86bf58c4679e21e5259929d135470ac5.png";